import React from 'react';
import { Sprite } from '@agissc/ktag-map';
import classNames from 'classnames';

interface MessageBoxProps {
  message: string | React.ReactNode;
  type: 'information' | 'negative';
  additionalClassNames?: string;
}

const MessageBox = ({ message, type, additionalClassNames }: MessageBoxProps) => {
  return (
    <p className={additionalClassNames}>
      <Sprite
        id={type === 'negative' ? 'exclamation-circle' : 'i-circle'}
        additionalClassNames={classNames('message_icon', {
          identify_error_icon: type === 'negative',
        })}
      />
      {message}
    </p>
  );
};

export default MessageBox;
